import { render, staticRenderFns } from "./default-close.vue?vue&type=template&id=189d2bbf&"
import script from "./default-close.vue?vue&type=script&lang=ts&"
export * from "./default-close.vue?vue&type=script&lang=ts&"
import style0 from "./default-close.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports